import config from 'config';
import { AvailableTimes } from 'domains/calendars/types';
import ScheduleConsultation from 'domains/consultations/Components/ScheduleConsultation';
import { ScheduleContextV3, withScheduleMachineStateV3 } from 'domains/signupv3/schedule/context';
import { TimeZone } from 'domains/timezone';
import { useCallback } from 'react';

const ScheduleWrapper = () => {
  const availableConsultDates = ScheduleContextV3.useSelector(({ context }) => context.data.availableConsultDates);
  const { send } = ScheduleContextV3.useActorRef();

  const supportEmail = config.get('supportEmail');

  const onSubmit = useCallback(
    (value: Date, displayTimezone: TimeZone) => {
      send({
        type: 'submitConsultationDate',
        consultationDate: value,
        consultationTimezone: displayTimezone,
      });
    },
    [send],
  );

  return (
    <ScheduleConsultation
      onSubmit={onSubmit}
      availableTimes={availableConsultDates as AvailableTimes}
      supportEmail={supportEmail}
    />
  );
};

export const ScheduleV3EnterConsultationDate = withScheduleMachineStateV3(ScheduleWrapper, 'enterConsultationDate');
